import axios from 'axios';
import qs from 'qs';

export default {
  getData(context) {
    axios
      .get(`${process.env.VUE_APP_DATA_PATH}`)
      .then((response) => {
        context.commit('setData', response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  },
  getSeries(context) {
    axios
      .get(`${process.env.VUE_APP_SERIES_PATH}`)
      .then((response) => {
        context.commit('setSeriesData', response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  },
  getVideos(context) {
    axios
      .get(`${process.env.VUE_APP_VIDEOS_PATH}`)
      .then((response) => {
        context.commit('setVideos', response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  },
  getSeriesVideos(context, videos) {
    context.commit('setSeriesVideos', videos);
  },
  addVideo(context, video) {
    // todo - check if not already in list
    context.commit('setSeriesVideos', [
      ...context.state.currentSeriesVideos,
      video,
    ]);
  },
  removeVideo(context, video) {
    let index;

    context.state.currentSeriesVideos.forEach((item, i) => {
      if (parseInt(video.id, 10) === parseInt(item.id, 10)) {
        index = i;
      }
    });
    let newList = context.state.currentSeriesVideos;
    newList.splice(index, 1);
    context.commit('setSeriesVideos', newList);
  },
  saveSeries(context, payload) {
    context.commit('setLoadStatus', true);
    axios
      .post(`${process.env.VUE_APP_SERIES_MANAGE}`, qs.stringify(payload))
      .then((response) => {
        console.log(response.data);
        // todo update series in state
        context.commit('setLoadStatus', false);
      })
      .catch((e) => {
        console.log(e);
      });
  },
  toggleTeachersModal(context, show) {
    context.commit('toggleTeachersModal', show);
  },
  addTeacher(context, tid) {
    context.commit('addTeacher', tid);
  },
  removeTeacher(context, tid) {
    context.commit('removeTeacher', tid);
  },
};
